@import '../../../globals/main.scss';

pn-proxio-findprice-result {
  [slot='insurance'] {
    display: flex;
    justify-content: center;
  }

  .insurance-box {
    padding: 0.4rem 0.8rem;
    border-radius: 0.8rem;
    background-color: $blue200;
    text-align: center;
    font-size: 1.2rem;
    font-weight: 400;
    margin-bottom: 2.4rem;
  }
}
